import { closeModal } from "../helpers/modalFunctions";
import { staticMessagesError } from "../helpers/staticMessagesError";
import { postBlock } from "../service/postBlock";
import { toastUpdate } from "../utils/notifications/toast";

export const addGroupProducts = async (
    values: {
        name: string,
        description: string
    },
    sellerOwnerPayId: string,
    refresh: boolean,
    setRefresh:(value: boolean) => void
): Promise<void> => {
    const { isError } = await postBlock("/donations/camp/create", {
        sellerOwnerPayId: sellerOwnerPayId,
        description: values.description,
        active: true,
        amount: 0
    });

    if(isError) {
        toastUpdate(
            "createGroup", 
            "error", 
            2000, 
            staticMessagesError.CREATE_GROUP_PRODUCT
        )
    }

    else {
        setRefresh(!refresh)
        toastUpdate(
            "createGroup", 
            "success", 
            2000, 
            "Grupo criado com sucesso!"
        )
        closeModal("addGroupProduct")
    }
}